import { useAdminAuthStore } from '@/stores/admin/auth.js'
import { handleMaintenance } from './handleMaintenance.js'
import { createHttpClient } from './httpClient.js'

export const apiClient = createHttpClient({
  baseURL: import.meta.env.VITE_BACKEND_ADMIN_URL,
  requestInterceptor: () => {
    const authStore = useAdminAuthStore()
    const token = authStore.getToken

    if (token) {
      return { Authorization: `Bearer ${token}` }
    }

    return {}
  },
  errorInterceptor: (error, retry) => {
    const authStore = useAdminAuthStore()

    if (error.response?.status === 401 && authStore.getToken) {
      // Sync cross-tab token and replay the request so the user's action isn't dropped.
      if (authStore.syncFromStorage()) {
        return retry()
      }
      authStore.handleSessionExpired()
      throw error
    }

    if (error.response?.status === 503) {
      handleMaintenance()
    }

    throw error
  }
})
